type MotionDeviceEvent = typeof DeviceMotionEvent & {
  requestPermission?: () => Promise<'granted' | 'denied'>;
};

export async function requestMotionPermission() {
  if (typeof window === 'undefined' || typeof DeviceMotionEvent === 'undefined') return false;
  const deviceMotion = DeviceMotionEvent as MotionDeviceEvent;
  if (typeof deviceMotion.requestPermission === 'function') {
    try {
      return (await deviceMotion.requestPermission()) === 'granted';
    } catch {
      return false;
    }
  }
  return true;
}

export function setupShakeListener(onShake: () => void, sensitivity: number) {
  if (typeof window === 'undefined' || typeof DeviceMotionEvent === 'undefined') return () => undefined;
  let lastX = 0;
  let lastY = 0;
  let lastZ = 0;
  let hasBaseline = false;
  let lastShakeAt = 0;
  const threshold = 21 - sensitivity * 1.35;

  const handleMotion = (event: DeviceMotionEvent) => {
    const acceleration = event.accelerationIncludingGravity;
    if (!acceleration || acceleration.x === null || acceleration.y === null || acceleration.z === null) return;
    if (!hasBaseline) {
      lastX = acceleration.x;
      lastY = acceleration.y;
      lastZ = acceleration.z;
      hasBaseline = true;
      return;
    }
    const delta = Math.abs(acceleration.x - lastX) + Math.abs(acceleration.y - lastY) + Math.abs(acceleration.z - lastZ);
    lastX = acceleration.x;
    lastY = acceleration.y;
    lastZ = acceleration.z;
    const now = Date.now();
    if (delta > threshold && now - lastShakeAt > 1100) {
      lastShakeAt = now;
      onShake();
    }
  };

  window.addEventListener('devicemotion', handleMotion);
  return () => window.removeEventListener('devicemotion', handleMotion);
}
